module.exports = __webpack_public_path__ + "static/media/cloud.e5a308f2.svg";